import { z } from 'zod'
import { ReceivingPeriodSchema } from '@shared/contracts/enums'

export const DocumentationStatusSchema = z.enum([
  'NAO_INICIADO',
  'PENDENTE',
  'APROVADO',
  'REPROVADO',
])
export type DocumentationStatus = z.infer<typeof DocumentationStatusSchema>

export const UserProfileSchema = z
  .object({
    phone: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    birthDate: z.string().optional(),
    country: z.literal('BR').optional(),
    businessType: z.enum(['INDIVIDUAL', 'COMPANY']).optional(),
    documentType: z.enum(['CPF', 'CNPJ']).optional(),
    documentNumber: z.string().optional(),
    politicalExposure: z.enum(['none', 'existing']).optional(),
    businessName: z.string().optional(),
    legalName: z.string().optional(),
    monthlyRevenue: z.number().optional(),
    businessProfile: z
      .object({
        mcc: z.string().optional(),
        productDescription: z.string().optional(),
        url: z.string().optional(),
      })
      .optional(),
    representative: z
      .object({
        documentNumber: z.string().optional(),
        title: z.string().optional(),
      })
      .optional(),
    address: z
      .object({
        line1: z.string().optional(),
        line2: z.string().optional(),
        city: z.string().optional(),
        state: z.string().optional(),
        postalCode: z.string().optional(),
        country: z.literal('BR').optional(),
      })
      .optional(),
  })
  .partial()

export type UserProfile = z.infer<typeof UserProfileSchema>

export const SessionUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string().optional(),
  phone: z.string().optional(),
  emailVerified: z.boolean().default(false),
  documentationStatus: DocumentationStatusSchema.default('NAO_INICIADO'),
  isSaleBlocked: z.boolean().default(false),
  receivingPeriod: ReceivingPeriodSchema.nullable().optional(),
  profile: UserProfileSchema.nullable().optional(),
})

export type SessionUser = z.infer<typeof SessionUserSchema>
